import React from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Button } from 'src/chrome'

import styles from './modalFooter.module.scss'
import { GiftFragment } from 'src/graphql'
import { Spacer, Text } from '@sendoutcards/quantum-design-ui'

type ModalFooterProps = {
  index: number
  gift: GiftFragment
  addGift: (gift: GiftFragment) => void
  handleChange: (value: number) => void
}

const ModalFooter: React.FC<ModalFooterProps> = props => {
  const { addGift, gift, index } = props

  const handleChangeTab = (event: React.ChangeEvent<{}>, value: number) => {
    props.handleChange(value)
  }
  return (
    <>
      <Tabs
        className={styles.tabsContainer}
        value={index}
        onChange={handleChangeTab}
      >
        <Tab
          value={0}
          label={<Text type="body">Description</Text>}
          style={{ fontSize: 'unset' }}
        />
        <Tab
          value={1}
          label={<Text type="body">Detail</Text>}
          style={{ fontSize: 'unset' }}
        />
        <Tab
          value={2}
          label={<Text type="body">Packaging</Text>}
          style={{ fontSize: 'unset' }}
        />
        <Tab
          value={3}
          label={<Text type="body">Shipping</Text>}
          style={{ fontSize: 'unset' }}
        />
      </Tabs>
      <div className={styles.priceAndButtonWrapper}>
        <div className={styles.priceContainer}>
          <Spacer space="x1" />
          <Text type="caption">PRICE:</Text>
          <Text type="title" color="primaryBody">
            {`${gift.defaultVariation && gift.defaultVariation.price.asString}`}
          </Text>
        </div>
        <div className={styles.selectGiftButtonContainer}>
          <Button
            id={'add_gift_btn'}
            className={styles.selectGiftButton}
            title={'Add Gift'}
            buttonColor={'blue'}
            onClick={() => addGift(gift)}
          />
        </div>
      </div>
    </>
  )
}

export default ModalFooter
